import { render, staticRenderFns } from "./AmsRelationshipsCard.vue?vue&type=template&id=1307d33b&"
import script from "./AmsRelationshipsCard.vue?vue&type=script&lang=js&"
export * from "./AmsRelationshipsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports